import { ADMIN_ROLES, INVOICES_ADMIN } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

import { AuthController } from '../auth-controller';

export class AdminInvoicesController extends AuthController {
  public pageId = INVOICES_ADMIN;
  public path = '/admn/invoices';
  public routeName = 'invoices';
  public bundles = [];
  public pageTitle = 'controllers.invoices';
  public isAdminView = true;
  public accessRoles = [
    ADMIN_ROLES.INTERNAL_ADMIN,
    ADMIN_ROLES.INTERNAL_REV_OPS,
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_SALES,
    ADMIN_ROLES.INTERNAL_COLLECTIONS_MANAGER,
  ];
  public readOnlyAccessRoles = [
    ADMIN_ROLES.INTERNAL_ADMIN_VIEWER,
    ADMIN_ROLES.INTERNAL_TECH_SUPPORT,
    ADMIN_ROLES.INTERNAL_SALES,
    ADMIN_ROLES.INTERNAL_COLLECTIONS_MANAGER,
  ];
  public navIcon = 'payments';

  public component = codeSplit(
    () => import(/* webpackChunkName: "adminInvoices" */ '../../views/admin/admin-invoices'),
  );
  public exact = true;
}
